namespace $.$$ {
	export class $eve_app_source extends $.$eve_app_source {
		
		uri(): string {
			return this.uri_base() + this.uri_end()
		}
		
	}
}
